import { pie as d3pie } from 'd3';
function getStackArcs(data, valueAccessor, labelAccessor, colorAccessor, colorScale, innerRadius, outerRadius) {
  const pie = d3pie().value(valueAccessor).sort(null);
  const arcs = pie(data);
  const stackArcs = arcs.map(arc => ({
    key: labelAccessor(arc.data),
    ariaLabel: `${labelAccessor(arc.data)}, ${valueAccessor(arc.data)}`,
    innerRadius: innerRadius !== undefined && innerRadius < 1 ? 1 : innerRadius,
    outerRadius: outerRadius,
    startAngle: arc.startAngle,
    endAngle: arc.endAngle,
    padAngle: 0.01,
    fill: colorScale(colorAccessor(arc.data)),
    value: valueAccessor(arc.data),
    data: arc.data
  }));
  return stackArcs;
}
export default getStackArcs;